import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import { useEffect } from "react";
import { fetchProdotti } from "../../../features/Prodotti/prodottiThunk";
import { selectProdotti, selectError, selectIsLoading } from "../../../features/Prodotti/prodottiSlice";
import { CircularProgress, Box } from "@mui/material";
import { fetchCompanies } from "../../../features/company/companyThunk";

const SubProdotti = () => {
    const columns = [
        { field: "nomeProdotto", headerName: "Nome del prodotto", width: 296 },
        { field: "tipo", headerName: "Tipo", width: 189 },
        { field: "tipologia", headerName: "Tipologia", width: 189 },
        { field: "annoProduzione", headerName: "Anno di Produzione", width: 189 },
        { field: "gradazioneAlcolica", headerName: "Gradazione Alcolica", width: 189 },
        { field: "cod", headerName: "Cod.", width: 174 },
        { field: "codEan", headerName: "Cod. EAN", width: 174 },
        { field: "denominazione", headerName: "Denominazione", width: 174 },
        { field: "azioni", headerName: "Azioni", width: 120, sortable: false },
    ];
    const dispatch = useDispatch()
    const prodotti = useSelector(selectProdotti) || []
    const prodottiLoading = useSelector(selectIsLoading)
    const prodottiError = useSelector(selectError)
    const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);

    useEffect(() => {
        dispatch(fetchProdotti())
    }, [dispatch, selectSelectedCompany])
    useEffect(() => {
        dispatch(fetchCompanies())
      },[])
    const mappedData = prodotti.map((item) => ({
        id: item.id,
        nomeProdotto: item.commercial_name,
        tipo: item.tipo,
        tipologia: item.tipologia,
        annoProduzione: item.anno_di_produzione,
        gradazioneAlcolica: item.gradazione_alcolica,
        cod: item.product_code,
        codEan: item.ean_code,
        denominazione: item.denominazione?.toUpperCase(),
    }));
    return (
        <>
            <div className="pageTemplate">
                {prodottiLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
                        <CircularProgress color="primary" />
                    </Box>
                ) : (
                    <Table
                        data={mappedData?.length ? mappedData : []}
                        columns={columns}
                        navData={"structureProdotti"}
                        deleteFunctions={"deleteProdottoData"} />
                )}

            </div>
        </>
    );
};
export default SubProdotti;